import React from 'react';

const useDelayedState = <T extends any>(state: T, delay = 200) => {
  const [delayState, setDelayState] = React.useState<T>();
  const timeout = React.useRef<number>();
  const handleClear = React.useCallback(() => {
    if (timeout.current) {
      clearTimeout(timeout.current);
      timeout.current = undefined;
    }
  }, []);
  React.useEffect(() => {
    handleClear();
    // @ts-ignore
    timeout.current = setTimeout(() => {
      setDelayState(state);
    }, delay);

    return handleClear;
  }, [delay, handleClear, state]);

  return delayState;
};

export default useDelayedState;
